"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var StaticReqMapping = /*#__PURE__*/function () {
  function StaticReqMapping(rules) {
    (0, _classCallCheck2.default)(this, StaticReqMapping);
    (0, _defineProperty2.default)(this, "defParams", {
      __module__: "",
      // 2, 3
      __objId__: "",
      // moduleId
      __typeArr__: "",
      // rules 自定义
      isRefresh: false
    });
    (0, _defineProperty2.default)(this, "2", "webinar");
    (0, _defineProperty2.default)(this, "3", "seminar");
    this.rules = rules;
  }
  /**
   * 拼接并返回静态请求地址
   * @param url
   * @param params
   * @returns {string}
   */


  (0, _createClass2.default)(StaticReqMapping, [{
    key: "getStaticUrl",
    value: function getStaticUrl(url, params) {
      if (this.rules[url]) {
        var staticInfo = this.rules[url],
            tenantId = params.tenantId,
            __module__ = params["__module__"],
            __objId__ = params["__objId__"],
            __typeArr__ = params["__typeArr__"],
            preUrl = "/".concat(tenantId),
            contentUrl; // url是否区分模块(在不同模块中调用不同的静态地址，例如报名表单、问卷、投票、文件)

        if (staticInfo.multiple) {
          preUrl += "/".concat(this[__module__], "/").concat(__objId__);
          var staticUrls = __module__ ? staticInfo.staticUrl[__module__] : staticInfo.staticUrl.def;
          contentUrl = (0, _typeof2.default)(staticUrls) === "object" ? staticUrls[__typeArr__] : staticUrls;
        } else {
          contentUrl = staticInfo.staticUrl;
        }

        return this.replaceParams(preUrl + contentUrl, staticInfo.regList, params);
      }

      return "";
    }
    /**
     * 替换静态化参数
     * @param staticUrl
     * @param regList
     * @param params
     * @returns {*}
     */

  }, {
    key: "replaceParams",
    value: function replaceParams(staticUrl, regList, params) {
      regList.forEach(function (reg) {
        staticUrl = staticUrl.replace("$".concat(reg, "@"), params[reg]);
      });
      return staticUrl;
    }
  }]);
  return StaticReqMapping;
}();

var rules = {}; // 获取线上会议信息

rules["/api/webinar/get"] = {
  staticUrl: "/webinar/$webinarId@/info.json",
  regList: ["webinarId"]
}; // 获取自定义表单(报名表单)的地址

rules["/api/customform/get"] = {
  staticUrl: {
    "2": "/signup/$customFormId@.json",
    "3": "/signup/$customFormId@.json",
    def: "/customform/$customFormId@.json"
  },
  regList: ["customFormId"],
  multiple: true
}; // 获取问卷

rules["/api/questionnaire/get"] = {
  staticUrl: {
    "2": "/questionnaire/$questionnaireId@.json",
    "3": "/questionnaire/$questionnaireId@.json",
    def: "/questionnaire/$questionnaireId@.json"
  },
  regList: ["questionnaireId"],
  multiple: true
}; // 获取投票信息

rules["/poll/get"] = {
  staticUrl: {
    "2": "/poll/$pollId@.json",
    "3": "/poll/$pollId@.json",
    def: "/poll/$pollId@.json"
  },
  regList: ["pollId"],
  multiple: true
}; // 字典表

rules["/dic/params/getTree"] = {
  staticUrl: "/dic/list/$dicId@.json",
  regList: ["dicId"]
}; // 文件列表

rules["/file/getList"] = {
  staticUrl: {
    "2": {
      file: "/file/list/info/$fileIds@.json",
      folder: "/file/folder/info/$folderId@.json"
    },
    "3": {
      file: "/file/list/info/$fileIds@.json",
      folder: "/file/folder/info/$folderId@.json"
    },
    def: {
      file: "/file/list/info/$fileIds@.json",
      folder: "/file/folder/info/$folderId@.json"
    }
  },
  regList: ["fileIds", "folderId"],
  multiple: true
}; // 获取登录注册的地址

rules["/member/form/GetForNewForm"] = {
  staticUrl: "/member/form/$memberFormId@/infos.json",
  regList: ["memberFormId"]
}; // 获取注册表单信息

rules["/api/member/form/get"] = {
  staticUrl: "/member/form/$formId@/info.json",
  regList: ["formId"]
}; // 忘记密码 - 表单信息

rules["/member/schema/orderUnique"] = {
  staticUrl: "/member/form/$memberFormId@/fields.json",
  regList: ["memberFormId"]
};
rules["/api/seminar/get"] = {
  // staticUrl: "/custom/tencent/seminar/$seminarId@/info.json",
  staticUrl: "/seminar/$seminarId@/info.json",
  regList: ["seminarId"]
};
rules["/api/seminar/subseminar/information/query"] = {
  staticUrl: "/seminar/$seminarId@/subSeminar/list.json",
  regList: ["seminarId"]
};
rules["/api/seminar/subseminar/get"] = {
  staticUrl: "/seminar/$seminarId@/subSeminar/$subSeminarId@.json",
  regList: ["seminarId", "subSeminarId"]
};
rules["/seminar/guest/getList"] = {
  staticUrl: "/seminar/$seminarId@/guest.json",
  regList: ["seminarId"]
}; // 栏目列表

rules["/api/article/category/sub/query"] = {
  staticUrl: "/article/category/$articleCategoryId@.json",
  regList: ["articleCategoryId"]
}; // 文章列表

rules["/api/article/query"] = {
  staticUrl: "/article/list/$articleCategoryId@.json",
  regList: ["articleCategoryId"]
};
var staticReqMapping = new StaticReqMapping(rules);
var _default = staticReqMapping;
exports.default = _default;